import { Meta, Title } from '@angular/platform-browser';
import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { services } from '../../services';
import { DivisionsService } from '../../../../../../shared/modules/core/services/divisions.service';
import { TranslationService } from '../../../../../../shared/services/translations.service';
import { CookieService } from 'ngx-cookie-service';

@Component({
  selector: 'app-tft-solo-net-wins',
  templateUrl: './tft-net-wins.component.html'
})
export class TftNetWinsComponent {
  service = 'netwins';
  availableServices = services['tft'].filter(service => service.service !== this.service);

  serviceParams = {
    game: 'tft',
    service: 'netwins',
    type: 'solo',
    title: {
      en: 'Net Wins',
    },
    subtitle: {
      en: 'Guaranteed Positive Number of Wins, with the Booster playing in your account.',
      fr: 'Nombre positif de victoires garanti, avec le Booster jouant sur votre compte.',
      de: 'Garantierte positive Anzahl an Siegen, während der Booster auf <br> deinem Konto spielt.',
      pt: 'Número garantido de net wins, com o booster a jogar na tua conta.',
      es: 'Número positivo garantizado de victorias, con el Booster jugando en tu cuenta.',
    },
    start: DivisionsService.getValueByRank('Silver I', 'tft'),
    desired: 3,
    serviceName: 'Net Wins',
    min: 1,
    max: 3
  }

  serviceFaqs = {
    en: [
      {
        question: "What Is A Net Win Boost?",
        answer: "A Net Win boost is the difference between the number of victories and losses. For each loss, you receive an additional win. ex: 2 Net Wins = 2W-0L or 3W-1L."
      },
      {
        question: "What Do You Consider To Be A Win Or A Loss?",
        answer: "Any result above or equal to 4th place is a win. In Double Up any result above or equal to 2nd place is a win."
      },
      {
        question: "What If I Reach A New Division And Still Have Net Wins Remaining?",
        answer: "In ranks below Diamond we play one division above the initial rank. In Diamond+, net wins are only valid for the purchased division."
      },
      {
        question: "Can I Purchase Net Wins Before My Placements Are Complete?",
        answer: "Only accounts with all placements completed are eligible for Net Wins."
      },
      {
        question: "Can I Play While The Order Is Active?",
        answer: "Yes, unless you want to queue in the same ranking mode as the bought service. Other than that, schedule it in the order chat with your booster."
      },
      {
        question: "Can I Request The Same Booster For A Future Purchase?",
        answer: "Yes! Click the heart icon inside the order dashboard to favorite a booster, then easily reassign them to your future orders."
      }
    ],
    fr: [
      {
        question: "Qu\'est-ce qu\'un Boost de victoire nette?",
        answer: "Une victoire nette est la différence entre le nombre de victoires et le nombre de défaites. Pour chaque défaite, vous recevez une victoire supplémentaire. ex: 2 victoires nettes = 2V-0D ou 3V-1D."
      },
      {
        question: "Que considérez-vous comme une victoire ou une défaite?",
        answer: "Tout résultat supérieur ou égal à la 4ème place est une victoire. En Double Up, tout résultat supérieur ou égal à la 2ème place est une victoire."
      },
      {
        question: "Que se passe-t-il si j\'atteins une nouvelle division et qu\'il me reste des victoires nettes?",
        answer: "Dans les rangs inférieurs à Diamant, nous jouons une division au-dessus du rang initial. En Diamant+, les victoires nettes ne sont valables que pour la division achetée."
      },
      {
        question: "Puis-je acheter des victoires nettes avant que mes placements ne soient terminés?",
        answer: "Seuls les comptes dont tous les placements ont été effectués sont éligibles pour les victoires nettes."
      },
      {
        question: "Puis-je jouer pendant que la commande est active?",
        answer: "Oui, sauf si vous voulez jouer dans le même mode classé que le service acheté. Dans le cas contraire, planifiez-le dans le chat de commande avec votre booster."
      },
      {
        question: "Puis-je demander le même booster pour un prochain achat?",
        answer: "Oui ! Cliquez sur l\'icône en forme de cœur dans le tableau de bord de commande pour ajouter un booster en favori, puis réassignez-le facilement à vos prochaines commandes."
      }
    ],
    de: [
      {
        question: "Was ist ein Net Win Boost?",
        answer: "Ein Net Win Boost ist die Differenz zwischen der Anzahl der Siege und der Anzahl der Niederlagen. Für jede Niederlage erhältst du einen zusätzlichen Sieg. z.B.: 2 Net Wins = 2W-0L oder 3W-1L."
      },
      {
        question: "Was ist für dich ein Gewinn oder ein Verlust?",
        answer: "Jedes Ergebnis über oder gleich dem 4. Platz ist ein Gewinn. In Double Up ist jedes Ergebnis über oder gleich dem 2. Platz ein Gewinn."
      },
      {
        question: "Was passiert, wenn ich eine neue Division erreiche und noch Net Wins übrig habe?",
        answer: "In Rängen unterhalb von Diamond spielen wir eine Division über dem ursprünglichen Rang. In Diamond+ sind die Net Wins nur für die gekaufte Division gültig."
      },
      {
        question: "Kann ich Net Wins kaufen, bevor meine Platzierungen abgeschlossen sind?",
        answer: "Nur Konten, bei denen alle Platzierungen abgeschlossen sind, sind für Net Wins berechtigt."
      },
      {
        question: "Kann ich spielen, während die Bestellung aktiv ist?",
        answer: "Ja, es sei denn, du möchtest im gleichen Ranking-Modus wie der gekaufte Dienst spielen. Ansonsten planst du das mit deinem Booster im Auftragschat."
      },
      {
        question: "Kann ich denselben Booster auch für einen späteren Kauf anfordern?",
        answer: "Ja! Klicke im Bestell-Dashboard auf das Herzsymbol, um einen Booster zu deinen Favoriten hinzuzufügen, und weise ihn dann ganz einfach zukünftigen Bestellungen zu."
      }
    ],
    pt: [
      {
        question: "O que é um Boost de Net Win?",
        answer: "Um Boost de Net Win é a diferença entre o número de vitórias e derrotas. Para cada derrota, você recebe uma vitória adicional. ex: 2 Net Wins = 2V-0D ou 3V-1D."
      },
      {
        question: "Como definem uma vitória ou uma derrota?",
        answer: "Qualquer resultado acima ou igual ao 4º lugar é uma vitória. Em Double Up, qualquer resultado acima ou igual ao 2º lugar é uma vitória."
      },
      {
        question: "E Se Eu Alcançar Uma Nova Divisão Ainda Com Net Wins Restantes?",
        answer: "Nos ranks abaixo de Diamond, jogamos uma divisão acima do rank inicial. Em Diamond+, as Net Wins são válidos apenas para a divisão comprada."
      },
      {
        question: "Posso Comprar Net Wins Antes De Terminar Os Placements?",
        answer: "Apenas contas com todas as colocações completas são elegíveis para Net Wins."
      },
      {
        question: "Posso Jogar Enquanto O Serviço Está Activo?",
        answer: "Sim, a menos que queiras fazê-lo no mesmo modo de jogo do serviço comprado. Excepto isso, basta falares e agendares com o teu booster."
      },
      {
        question: "Posso Escolher O Mesmo Booster Para Uma Compra Futura?",
        answer: "Sim! Clica no ícone de coração dentro do painel do pedido para marcar um booster como favorito e depois escolhe-o facilmente nos teus próximos pedidos."
      }
    ],
    es: [
      {
        question: "¿Qué es un \"Net Win Boost\"?",
        answer: "Un Boost de Net Win es la diferencia entre el número de victorias y derrotas. Por cada derrota, recibes una victoria adicional. ej: 2 Net Wins = 2W-0L o 3W-1L."
      },
      {
        question: "¿Qué considerais una victoria o una derrota?",
        answer: "Cualquier resultado por encima o igual al 4º puesto es una victoria. En Double Up, cualquier resultado por encima o igual al 2º puesto es una victoria."
      },
      {
        question: "¿Qué pasa si alcanzo una nueva división y aún me quedan Net Wins?",
        answer: "En rangos inferiores a Diamond se juega una división por encima del rango inicial. En Diamond+, las net wins solo son válidas para la división adquirida."
      },
      {
        question: "¿Puedo comprar ganancias netas antes de que se completen mis clasificaciones?",
        answer: "Sólo las cuentas con todas las clasificaciones completadas pueden optar a Net Wins."
      },
      {
        question: "¿Puedo jugar mientras la orden está activa?",
        answer: "Sí, a menos que quieras hacer cola en el mismo modo de clasificación que el servicio comprado. Aparte de eso, prográmalo en el chat de órdenes con tu booster."
      },
      {
        question: "¿Puedo solicitar el mismo booster para una futura compra?",
        answer: "¡Sí! Haz clic en el ícono de corazón dentro del panel del pedido para añadir un booster a favoritos y así poder reasignarlo fácilmente en tus futuros pedidos."
      }
    ]
  }

  private page = {
    title: {
      "en": "TFT Boost - Premium Boosting for Teamfight Tactics",
      "fr": "Boost TFT - Boosting Premium pour Teamfight Tactics",
      "de": "TFT Boost - Premium Boosting für Teamfight Tactics",
      "pt": "TFT Boost - Boosting Premium Net Wins para Teamfight Tactics",
      "es": "TFT Boost - Boosting Premium para Teamfight Tactics",
    },
    metaDescription: {
      "en": "The best Elo Boosting Service to win LP and increase your MMR quickly, easily, and affordably. Get started now and see the results for yourself!",
      "fr": "Le meilleur service de boosting d\'Elo pour gagner des LP et augmenter votre MMR rapidement, facilement et à un prix abordable. Commencez dès maintenant et voyez les résultats par vous-même!",
      "de": "Der beste Elo Boosting Service, um schnell, einfach und günstig LP zu verdienen und deine MMR zu erhöhen. Beginne jetzt und überzeuge dich selbst von den Ergebnissen!",
      "pt": "O melhor serviço de Elo Boosting para ganhar LP e aumentar rapidamente, facilmente e de forma acessível o teu MMR. Comece agora mesmo e ve os resultados por ti mesmo!",
      "es": "El mejor servicio de Elo Boosting para ganar LP y aumentar tu MMR de forma rápida, fácil y asequible. ¡Empieza ahora y comprueba los resultados por ti mismo!",
    }
  }

  lang: string = 'en';

  constructor(meta: Meta, title: Title, private route: ActivatedRoute, private router: Router, private translationService: TranslationService, private cookie: CookieService) {
    this.route.params.subscribe(params => {
      if (Object.keys(params).length === 0) {
        const url = this.router.url.split('/');
        if (this.translationService.validLangs.includes(url[1])) {
          this.lang = url[1];
        } else {
          this.lang = this.cookie.get('gg-lang') || 'en';
        }
      } else {
        this.lang = params['lang'] || 'en';
      }
    });

    title.setTitle(this.page.title[this.lang] || this.page.title['en']);

    meta.updateTag(
      {
        name: 'description',
        content: this.page.metaDescription[this.lang] || this.page.metaDescription['en']
      },
    );
  }
}